/* Sweetened/Unsweetened toggle shared by product cards and the PDP.
   Both states' data are rendered server-side onto the radio inputs (via the
   sibling_product metafield), so switching is a pure DOM update — no
   network fetch needed. On the PDP the widget also carries data-pushstate,
   which updates the address bar (via history.pushState) so the URL always
   matches the option shown, without a full navigation. */
document.addEventListener('change', function (e) {
  var input = e.target.closest('[data-sweetness-input]');
  if (!input) return;
  var widget = input.closest('[data-sweetness-widget]');
  if (!widget) return;
  var data = input.dataset;

  var img = widget.querySelector('[data-role="image"]');
  if (img && data.image) img.src = data.image;

  var badge = widget.querySelector('[data-role="badge"]');
  if (badge && data.badge !== undefined) badge.innerHTML = data.badge;

  var thumbsContainer = widget.querySelector('[data-role="thumbs"]');
  if (thumbsContainer && data.thumbs) {
    try {
      var thumbUrls = JSON.parse(data.thumbs);
    } catch (err) {
      thumbUrls = [];
    }
    thumbsContainer.innerHTML = '';
    if (thumbUrls.length > 1) {
      thumbUrls.forEach(function (url, i) {
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.setAttribute('data-pdp-thumb', '');
        btn.setAttribute('data-src', url);
        if (i === 0) btn.classList.add('is-active');
        var thumbImg = document.createElement('img');
        thumbImg.src = url.replace(/width=\d+/, 'width=128');
        thumbImg.alt = (data.name || '') + ' — photo ' + (i + 1);
        btn.appendChild(thumbImg);
        btn.addEventListener('click', function () {
          thumbsContainer.querySelectorAll('[data-pdp-thumb]').forEach(function (b) { b.classList.remove('is-active'); });
          btn.classList.add('is-active');
          if (img) img.src = url;
        });
        thumbsContainer.appendChild(btn);
      });
    }
  }

  var price = widget.querySelector('[data-role="price"]');
  if (price && data.price) price.textContent = data.price;

  var comparePrice = widget.querySelector('[data-role="compare-price"]');
  if (comparePrice) {
    if (data.comparePrice) {
      comparePrice.textContent = data.comparePrice;
      comparePrice.hidden = false;
    } else {
      comparePrice.hidden = true;
    }
  }

  var addBtn = widget.querySelector('[data-role="add-button"]');
  if (addBtn && data.variantId) addBtn.setAttribute('data-variant-id', data.variantId);

  widget.querySelectorAll('[data-role="href"]').forEach(function (a) {
    if (data.url) a.href = data.url;
  });

  var name = widget.querySelector('[data-role="name"]');
  if (name && data.name) name.textContent = data.name;

  if (widget.hasAttribute('data-pushstate') && data.url) {
    window.history.pushState({}, '', data.url);
    if (data.title) document.title = data.title;
  }

  /* Judge.me's full review widget (#judgeme_product_reviews, PDP only — the
     shop-grid cards don't have one) is a Vue app that self-initializes once
     from a module-scoped singleton, keyed by DOM element reference — it has
     no public re-init API, so changing data-id on the existing element does
     nothing. The only way to make it re-render for the sibling's product is
     to swap in a genuinely new, not-yet-initialized container element and
     re-run their init script. Their loader is idempotent per script URL (the
     browser only evaluates an ES module's top-level code once per exact
     URL), so a cache-busting query string is required to force a second
     evaluation — that's what actually re-triggers their DOM scan and picks
     up the fresh container. Confirmed empirically in a real page (not just
     read from their source) before writing this. */
  var reviewsWidget = document.getElementById('judgeme_product_reviews');
  if (reviewsWidget && data.reviewId && window.jdgm && reviewsWidget.getAttribute('data-id') !== data.reviewId) {
    var reviewScriptEl = document.querySelector('script[src*="review_widget.js"]');
    var reviewScriptBase = reviewScriptEl ? reviewScriptEl.src.split('?')[0] : null;
    if (reviewScriptBase) {
      var freshWidget = document.createElement('div');
      freshWidget.id = 'judgeme_product_reviews';
      freshWidget.className = reviewsWidget.className;
      freshWidget.setAttribute('data-product-title', data.name || '');
      freshWidget.setAttribute('data-id', data.reviewId);
      freshWidget.setAttribute('data-product-id', data.reviewId);
      freshWidget.setAttribute('data-widget', 'review');
      freshWidget.setAttribute('data-auto-install', 'false');
      freshWidget.setAttribute('data-shop-reviews-count', reviewsWidget.getAttribute('data-shop-reviews-count') || '0');
      freshWidget.setAttribute('data-entry-point', 'review_widget.js');
      freshWidget.setAttribute('data-entry-key', 'review-widget/main.js');
      reviewsWidget.replaceWith(freshWidget);

      var reimportScript = document.createElement('script');
      reimportScript.type = 'module';
      reimportScript.src = reviewScriptBase + '?cachebust=' + Date.now();
      document.body.appendChild(reimportScript);
    }
  }
});

/* The option labels contain real links (crawlable URLs to each product).
   For shoppers, a click on the link should behave exactly like clicking the
   radio: switch in place, no page load. A link inside a <label> doesn't
   activate the label's input on its own, so do it here. */
document.addEventListener('click', function (e) {
  var link = e.target.closest('[data-sweetness-link]');
  if (!link) return;
  var label = link.closest('label');
  var input = label && label.querySelector('[data-sweetness-input]');
  if (!input || !input.closest('[data-sweetness-widget]')) return;
  e.preventDefault();
  if (!input.checked) {
    input.checked = true;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  }
});
